module.exports = __webpack_public_path__ + "static/media/download.18632b8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/download.svg
// module id = 122
// module chunks = 2